import {
  InfiniteList,
} from 'react-admin';
import CatalogListToolbar from './CatalogListToolbar';
import CatalogDataTable from './CatalogDataTable';
import { CatalogListActions } from './CatalogListActions';
import { useTitle } from '@src/hooks/useTitle';

const CatalogItemList = () => {
  const { title } = useTitle('Catalog Management');

  return (
    <InfiniteList
      perPage={25}
      sort={{ field: 'title', order: 'ASC' }}
      title={title}
      actions={<CatalogListActions />}
      sx={{
        '& .RaList-content': {
          paddingTop: 0,
        },
        '& .RaList-main': {
          marginTop: 0,
        }
      }}
    >
      <CatalogListToolbar />
      <CatalogDataTable />
    </InfiniteList>
  );
};

export default CatalogItemList;
